import React, { useEffect, useState } from 'react'

export function Toast({ message, type = "general", duration, className }) {
    const [showAdd, setShowAdd] = useState(true)
    const [showRemove, setShowRemove] = useState(false)

    useEffect(() => {
        const addTimer = setTimeout(() => {
            setShowAdd(false)
        }, 200)

        const removeClassTimer = setTimeout(() => {
            setShowRemove(true)
        }, (duration - 350))

        return () => {
            clearTimeout(addTimer)
            clearTimeout(removeClassTimer)
        }
    }, [])

    return <div className={`${className} toast toast-${type} ${showAdd && "add-toast"} ${showRemove && "remove-toast"}`}>{message}</div>
}